"use client";

import SiteNav from "@/components/SiteNav";
import Login from "@/components/pages/Login";

export default function LoginPage() {
  return (
    <>
      <SiteNav />
      <Login />
    </>
  );
}
